// A $( document ).ready() block.
$(document).ready(function() {
  console.log('ourStoryLanding ready!');

  // story-landing-nav
  const anchorSelecteres = $('[data-anchor-selector]');

  anchorSelecteres.each(function() {
    const anchorLink = $(this).attr('data-anchor-selector');
    const anchorText = $(this).attr('data-anchor-text');
    const makeLink = $('<a></a>')
      .text(anchorText)
      .attr('href', `#${anchorLink}`);
    $('#story-landing-nav').append(makeLink);
  });

  $(document).on('click', '[data-tab-panel-header]', function() {
    $(this)
      .parents('[data-tab-panel]')
      .toggleClass('active');
  });

  $('[data-fabrics-hover]')
    .mousemove(function(e) {
      const hoverImage = $(this).find('.contnet--hover__image');

      if (hoverImage) {
        hoverImage.stop(1, 1).fadeIn();
        hoverImage.offset({
          top: e.pageY - hoverImage.outerHeight(),
          left: e.pageX - hoverImage.outerWidth() / 2,
        });
      }
    })
    .mouseleave(function() {
      const hoverImage = $(this).find('.contnet--hover__image');

      if (hoverImage) {
        hoverImage.fadeOut();
      }
    });
});

$(document).on('click', '#story-landing-nav a', function(event) {
  event.preventDefault();
  var desiredHeight = $(window).height();
  $('body, html').animate(
    {
      scrollTop: $(this.hash).offset().top - 80,
    },
    1000
  );
});
